import React, { useState, useRef } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import ButtonBase from '@material-ui/core/ButtonBase';

export default ({ titulo = '', Conteudo, configRecursos = [] }) => {
  const intl = useIntl();

  const [currentTab, setCurrentTab] = useState(0);

  const topoConteudoMobile = useRef(null);

  const setTab = (tabIndex) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setCurrentTab(tabIndex);

    topoConteudoMobile.current.scrollIntoView();
  };

  return (
    <>
      <div className="tituloProduto mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 pt-3 pb-3 contatoTitulo">
              <h1 className="tt-u m-0">{titulo}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-md-12 produtosInterno">
            <h2 className="tituloProdutoInterno">{intl.formatMessage({ id: 'O que é?' })}</h2>
            <Conteudo />
          </div>
        </div>
        <div className="row mt-5">

          <div className="col-lg-3 col-12 menuLateral">
            <h3 className="text-center">{intl.formatMessage({ id: 'Principais Recursos' })}</h3>
            {configRecursos && configRecursos.length ? (
              <ul className="tabs" id="menuInterno">
                {configRecursos.map((config, index) => (
                  <ButtonBase
                    key={config.titulo}
                    onClick={setTab(index)}
                    onKeyDown={setTab(index)}
                    className={`tab-link active ${currentTab === index ? 'current' : ''}`}
                    style={{ width: '100%', justifyContent: 'flex-start' }}
                    component="li"
                  >
                    {config.titulo}
                  </ButtonBase>
                ))}
              </ul>
            ) : null}
          </div>

          <div className="col-lg-9 col-12 fundoCinzinha">
            <div className="someMobile" ref={topoConteudoMobile}></div>
            {configRecursos && configRecursos.length
              ? configRecursos.map((config, index) => (
                index === currentTab ? (
                  <div className="tab-content current" key={config.titulo}>
                    {config.texto}
                  </div>
                ) : null
              ))
              : null}
          </div>
        </div>
      </div>
    </>
  );
};
